import { Injectable } from '@angular/core';
import { baseUrl, heuristicsGateway } from './endpoint';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { GlobalEventsManager } from './global-events-manager';

@Injectable({
  providedIn: 'root'
})
export class HeuristicsService {

  private url = baseUrl + heuristicsGateway;

  constructor(
    private http: HttpClient,
    private globalEventsManager: GlobalEventsManager
  ) { }

  addHeuristic(src: any, dest: any): Observable<any[]> {
    const url = `${this.url}`;
    return this.http.post<any[]>(url, { token: localStorage.getItem('token'), function: 'addHeuristic', item1: src, item2: dest,
      item3: localStorage.getItem('userId'), item4: localStorage.getItem('userFullName') })
    .pipe(
      catchError(this.handleError('addHeuristic', []))
    );
  }

  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      if (error.error.text === 'expire') {
        this.globalEventsManager.logout(true);
      } else {
        if (error.error.text !== 'Could not Authenticate User') {
          console.error(error);
        }
      }
      return of(result as T);
    };
  }
}
